import React, {useEffect} from 'react'
import styled from 'styled-components'
import {CsvRow} from './types'
import {useI18n} from 'i18n/I18nContext'

interface Props {
  headers: string[]
  rows: CsvRow[]
  selectedEmailColumn: string
  setSelectedEmailColumn: (col: string) => void
  onNext: () => void
  onBack: () => void
}

const Step2SelectColumn: React.FC<Props> = ({
  headers,
  rows,
  selectedEmailColumn,
  setSelectedEmailColumn,
  onNext,
  onBack,
}) => {
  const {t} = useI18n()
  // Auto-detect email column
  useEffect(() => {
    if (!selectedEmailColumn && headers.length > 0) {
      const auto = headers.find((h) => /email|e-mail|mail/i.test(h))
      if (auto) setSelectedEmailColumn(auto)
    }
  }, [headers, selectedEmailColumn, setSelectedEmailColumn])

  const previewEmails = rows
    .slice(0, 5)
    .map((r) => r[selectedEmailColumn] || '')

  return (
    <Wrapper>
      <Header>
        <button className="disableBtnStyle" onClick={onBack}>
          {t('orgCsv.back')}
        </button>
        <button
          className="input__btn"
          onClick={onNext}
          disabled={!selectedEmailColumn}
        >
          {t('orgCsv.next')}
        </button>
      </Header>

      <MainContent>
        <Title>
          {t('orgCsv.step2Heading')} <br /> {t('orgCsv.step2Sub')}
        </Title>

        <div className="contact__select">
          {' '}
          <select
            value={selectedEmailColumn}
            onChange={(e) => setSelectedEmailColumn(e.target.value)}
          >
            <option value="" disabled>
              {t('orgCsv.selectColPh')}
            </option>
            {headers.map((h) => (
              <option key={h} value={h}>
                {h}
              </option>
            ))}
          </select>
        </div>
      </MainContent>

      {selectedEmailColumn && previewEmails.length > 0 && (
        <PreviewSection>
          <PreviewInfo>{t('orgCsv.columnPreviewHint')}</PreviewInfo>
          <EmailPreview>
            {previewEmails.map((e, i) => (
              <EmailCard key={i}>{e}</EmailCard>
            ))}
          </EmailPreview>
        </PreviewSection>
      )}
    </Wrapper>
  )
}

export default Step2SelectColumn

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`
const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`
const Title = styled.h3`
  margin: 0;
`
const MainContent = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;
  margin: 0 auto;
  text-align: center;
  margin-bottom: 25px;
`
const PreviewSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`
const PreviewInfo = styled.div`
  font-size: 14px;
  color: #5f6368;
`
const EmailPreview = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
`
const EmailCard = styled.div`
  background: #2e353a;
  padding: 6px 12px;
  border-radius: 5px;
  color: #ffffff;
`
